import React, { useEffect } from 'react';
import { Hero } from './components/sections/Hero';
import { Problems } from './components/sections/Problems';
import { PackIncludes } from './components/sections/PackIncludes';
import { PagePreviews } from './components/sections/PagePreviews';
import { KeyBenefit } from './components/sections/KeyBenefit';
import { FollowUp } from './components/sections/FollowUp';
import { About } from './components/sections/About';
import { Offer } from './components/sections/Offer';
import { Faq } from './components/sections/Faq';
import { FinalCta } from './components/sections/FinalCta';
import { SiteFooter } from './components/sections/SiteFooter';
import { StickyCta } from './components/ui/StickyCta';
export function App() {
  useEffect(() => {
    document.title = 'Asesoramiento para padres de futbolistas – Juan Ignacio Oliva, Agente FIFA';

    // Meta Domain Verification
    if (!document.querySelector('meta[name="facebook-domain-verification"]')) {
      const meta = document.createElement('meta');
      meta.name = 'facebook-domain-verification';
      meta.content = '9wfqwcalw402d9p954kaixicq4nv5s';
      document.head.appendChild(meta);
    }

    // Meta Pixel Code
    const win = window as any;
    if (!win.fbq) {
      ;
      (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          b.head.appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      win.fbq('init', '2564757130633111');
      win.fbq('track', 'PageView');
      const noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = 'https://www.facebook.com/tr?id=2564757130633111&ev=PageView&noscript=1';
      noscript.appendChild(img);
      document.head.appendChild(noscript);
    }
  }, []);
  return <div className="w-full bg-ink-950 font-sans text-body" data-id="element-0" data-mp="83qihiiybg7r">
      <Hero data-id="element-1" data-mp="3gm65dtoft15g" />
      <main data-id="element-2" data-mp="3glnzs6fvxakv">
        <Problems data-id="element-3" data-mp="3gja8m8obsiil" />
        <PackIncludes data-id="element-4" data-mp="3bmbgfvo82ln1" />
        <PagePreviews data-id="element-5" data-mp="3bn2ys4st6mvd" />
        <KeyBenefit data-id="element-6" data-mp="3bnmedeuzkz68" />
        <FollowUp data-id="element-7" data-mp="3bk6zod585s5c" />
        <About data-id="element-8" data-mp="3qb7inc3ll4fq" />
        <Offer data-id="element-9" data-mp="3qaxuzv60z9d7" />
        <Faq data-id="element-10" data-mp="3qbfur1rwc5pv" />
        <FinalCta data-id="element-11" data-mp="3qbzgyuokxg9p" />
      </main>
      <SiteFooter data-id="element-12" data-mp="3qdajysa7ajzr" />
      <StickyCta data-id="element-13" data-mp="3lkhfm5in9do7" />
    </div>;
}